import { ActionSet, createActionSet } from '@futrli/shared-services';

export const FORGOT_PASSWORD_SUBMIT: ActionSet = createActionSet('FORGOT_PASSWORD_SUBMIT');
